import { ThemeProvider } from "theme-ui";
import { KeycloakInstance } from "keycloak-js";
import { type JSX } from "react";
import AppContextProvider from "components/AppContextProvider";
import { AppRouter } from "components";
import { Responsive, theme } from "@dsaui";
import { Notification } from "@dsaui/components";
import "translations/i18n";

type AppProps = {
  keycloak: KeycloakInstance;
  authenticationError?: boolean;
};

const App = ({ keycloak, authenticationError = false }: AppProps): JSX.Element => {
  return (
    <AppContextProvider keycloak={keycloak} authenticationError={authenticationError}>
      <ThemeProvider theme={theme}>
        <Responsive>
          <AppRouter notification={<Notification />} />
        </Responsive>
      </ThemeProvider>
    </AppContextProvider>
  );
};

export default App;
